import React, { type JSX } from 'react';

interface ProgressProps {
  step: number;
}

/**
 * Form stepper, which highlights the current step. The step can either be
 * 1 or 2. The payment step in done at the external buckaroo page.
 */
export const Progess = ({ step }: ProgressProps): JSX.Element => (
  <div className="checkout__progress">
    <div className="checkout__progress-steps">
      <div className="checkout__step checkout__step_active">
        <span className="checkout__step-num">1.</span> Boeking
      </div>
      <div className={`checkout__step ${step === 2 ? 'checkout__step_active' : ''}`}>
        <span className="checkout__step-num">2.</span> Gegevens
      </div>
      <div className="checkout__step">
        <span className="checkout__step-num">3.</span> Betalen
      </div>
    </div>
  </div>
);
